var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeed150X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 10h28v24H8z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.164 28h-1.797v-8.273c-.672.755-1.448 1.31-2.328 1.664v-1.993c.5-.203 1.018-.566 1.555-1.09A4.221 4.221 0 0 0 14.71 16.5h1.453V28zM18.142 28v-2.195h1.805V28zM20.331 25.055l1.797-.227c.047.5.2.893.461 1.18.26.286.547.43.86.43.37 0 .687-.184.953-.551.265-.367.398-.931.398-1.692 0-.718-.132-1.25-.395-1.593-.263-.344-.597-.516-1.003-.516-.516 0-.98.279-1.391.836l-1.461-.258.922-5.96h4.758v2.054h-3.39l-.29 1.945c.406-.245.818-.367 1.234-.367.74 0 1.368.292 1.883.875.651.745.977 1.727.977 2.945 0 1.005-.278 1.93-.832 2.774-.555.843-1.348 1.265-2.38 1.265-.833 0-1.53-.272-2.089-.816-.56-.544-.897-1.32-1.012-2.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.02 28 2.453-4.273-2.351-4.024h2.203l1.203 2.281 1.266-2.28h2.11l-2.306 3.929L33.122 28H30.91l-1.383-2.57L28.122 28z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed150X);
export default __webpack_public_path__ + "static/media/speed150X.72b1eadb4bfff631989bfda7357900c4.svg";
export { ForwardRef as ReactComponent };